import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Scroll to in-page anchors after React Router navigates (e.g. /aboutus → /#pricing_sec). */
const HashScroll = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const id = hash.replace('#', '');

    const scrollToTarget = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    scrollToTarget();
    const retryMs = [50, 150, 350];
    const timers = retryMs.map((ms) => window.setTimeout(scrollToTarget, ms));

    return () => timers.forEach((t) => window.clearTimeout(t));
  }, [pathname, hash]);

  return null;
};

export default HashScroll;
